module.exports = __webpack_public_path__ + "static/media/lindsay_rassmann.dcb41ae3.jpg";